<template>
  <div class="company">
    <div class="companyImg">
      <!-- {{ itemInfo }} -->
      <img v-if="itemInfo[0].imageUrl" :src="url + itemInfo[0].imageUrl" />
      <img v-else src="~@/assets/images/moren.png" />
    </div>
    <div class="companyRight">
      <div class="companyItem">
        <span class="companyTitle"
          >{{ itemType == "1" ? "单位名称" : "设施名称" }}:</span
        >
        <span class="companyCon">{{
          itemType == "1" ? itemInfo[0].unitName : itemInfo[0].securityName
        }}</span>
      </div>
      <div class="companyItem">
        <span class="companyTitle"
          >{{ itemType == "1" ? "单位类别" : "设施类别" }}:</span
        >
        <span class="companyCon">{{
          itemType == "1"
            ? itemInfo[0].unitTypeDict
            : itemInfo[0].securityTypeDict
        }}</span>
      </div>
      <div class="companyItem" v-if="itemType == '1'">
        <span class="companyTitle">行业类别:</span>
        <span class="companyCon">{{ itemInfo[0].industryTypeDict }}</span>
      </div>
      <div class="companyItem">
        <span class="companyTitle"
          >{{ itemType == "1" ? "单位地址" : "安装地址" }}:</span
        >
        <span
          class="companyCon"
          style="width: 200px"
          :title="
            itemType == '1'
              ? itemInfo[0].regionInfo.levelName.replace(/\//g, '')
              : itemInfo[0].securityAddress
          "
          >{{
            itemType == "1"
              ? itemInfo[0].regionInfo.levelName.replace(/\//g, "")
              : itemInfo[0].securityAddress
          }}</span
        >
      </div>
      <div class="companyItem">
        <span class="companyTitle"
          >{{ itemType == "1" ? "联系电话" : "所属小区" }}:</span
        >
        <span class="companyCon">{{
          itemType == "1"
            ? itemInfo[0].unitTelphone
            : itemInfo[0].regionInfo && itemInfo[0].regionInfo.name
        }}</span>
      </div>
    </div>
  </div>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  onBeforeUpdate,
  onUpdated,
  watchEffect,
  // onBeforeUnmounted, // 组件销毁前
  // onUnmounted, // 组件销毁
  // onActiveted, // 条件:<keep-alive>
  // onDeActiveted, // 条件:<keep-alive>
  // onErrorCaptured, // 当捕获一个来自子孙组件的异常时激活
  // onRenderTracked // 跟踪状态变化 返回event所有变化属性
  // onRenderTriggered // 跟踪状态变化 返回event单个主要变化属性
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
export default defineComponent({
  name: "",
  components: {},
  props: {
    itemInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    itemType: {
      type: String,
      default: "1",
    },
  },
  setup(props) {
    const data = reactive({
      url: window.imgURL,
    });
    const refData = toRefs(data);
    onBeforeMount(() => {});
    onMounted(() => {});
    onBeforeUpdate(() => {});
    onUpdated(() => {});
    // onRenderTracked((event) => {console.log(event)})
    // watch([() => data],(newValue,oldValue) => {})
    return { ...refData };
  },
});
</script>
<style  lang='scss' scoped >
.company {
  width: 100%;
  height: 100%;
  display: flex;
  font-size: 14px;
  .companyImg {
    width: 128px;
    height: 100%;
    img {
      width: 100%;
      height: 91%;
    }
  }
  .companyRight {
    display: flex;
    flex-direction: column;
    .companyItem {
      display: flex;
      line-height: 30px;
      .companyTitle {
        padding: 0 15px;
      }
      .companyCon.font {
        color: aquamarine;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    span {
      height: 26px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>